export default __webpack_public_path__ + "static/media/2_0004.b65be7db.webp";